import * as analytic from '@anm/analytic';
import React, { useEffect, FC } from 'react';
import { useSelector } from 'react-redux';

import { hostedVideoSelectors } from '../../../../../store/modules/hostedVideo';
import CustomizationForm, { CustomizationFormProps } from '../../../CustomizationForm';
import PosterBlock, { PosterBlockProps } from '../../../PosterBlock';
import SidebarWrapper from '../../../SidebarWrapper';

export type AppearanceTabProps = CustomizationFormProps & Pick<PosterBlockProps, 'currentTime'>;

const AppearanceTab: FC<AppearanceTabProps> = ({ currentTime, isPosterSection = true, ...formProps }) => {
  useEffect(() => {
    analytic.trackOpenVideoAppearance();
  }, []);

  const configs = useSelector(hostedVideoSelectors.selectVideoConfigs);
  const videoData = useSelector(hostedVideoSelectors.selectVideoData);

  return (
    <SidebarWrapper>
      {videoData && isPosterSection && <PosterBlock {...{ currentTime, videoData }} />}
      {configs && <CustomizationForm {...{ configs }} {...formProps} />}
    </SidebarWrapper>
  );
};

export default AppearanceTab;
